import { propOr } from "ramda";
import { useSelector } from "react-redux";

const EMPTY_FACES = [];

const useFacesCount = () => {
  const meta = useSelector((state) => state.FacesSlice?.meta);
  const faces = useSelector((state) => state.FacesSlice?.faces ?? EMPTY_FACES);
  const totalFacesCount = propOr(faces.count, "totalCount", meta);

  return {
    totalFacesCount,
  };
};

export default useFacesCount;
